export default __webpack_public_path__ + "static/media/download.09f8f01a.svg";